import { NgModule } from '@angular/core';
import { PhAvatarComponent } from './ph-avatar.component';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'ngx-avatars';
import { PhCropperModule } from '@shared/components/ph-cropper/ph-cropper.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { HttpLoaderFactory } from 'src/app/app.functions';

@NgModule({
  declarations: [PhAvatarComponent],
  exports: [PhAvatarComponent],
  imports: [
    CommonModule,
    AvatarModule,
    PhCropperModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: true,
    }),
    FormsModule,
  ],
})
export class PhAvatarModule {}
